export default [
  {
    title: 'مدیریت کاربران',
    icon: 'bx bx-user',
    children: [
      {
        title: 'کاربران',
        route: { name: 'user' },
        resource: 'UserManager',
        action: 'show',
      },
      {
        title: 'نقش ها',
        route: { name: 'userrole' },
        resource: 'UserRoleManager',
        action: 'show',
      },
      {
        title: 'حکم های حقوقی',
        route: { name: 'salary' },
        resource: 'SalaryManager',
        action: 'show',
      },
      {
        title: 'واریزها و بدهی ها',
        route: { name: 'usertransaction' },
        resource: 'UserTransactionManager',
        action: 'show',
      },
      {
        title: 'کارکردها',
        route: { name: 'userordercategoryprocess' },
        resource: 'SalaryManager',
        action: 'show',
      },
      {
        title: 'تنخواه ها',
        route: { name: 'pettycash' },
        resource: 'PettyCashManager',
        action: 'show',
      },
    ],
  },
]
